import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';

import { NavMenuIntercomActions } from '@ninety/platform/state';

import { LearnSupportMenuActions } from './learn-support-menu.actions';

/**
 * Business consequences of the Learn & Support menu actions. Kept separate from
 * `LayoutAnalyticsEffects`, which only converts these same actions into Segment track calls.
 */
@Injectable()
export class LearnSupportMenuEffects {
  private readonly actions$ = inject(Actions);

  /**
   * Contacting support opens the Intercom messenger. The component dispatches only
   * `supportContacted` — the user's intent — and this effect carries out the consequence, so the
   * single action is the chokepoint that both this and the analytics effect react to.
   */
  showMessengerOnSupportContacted$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LearnSupportMenuActions.supportContacted),
      map(() => NavMenuIntercomActions.showMessenger())
    )
  );
}
